import { rem } from '@mantine/core'
import { notifications } from '@mantine/notifications'
import { IconCheck, IconX } from '@tabler/icons-react'

export function toastError(message: string) {
  notifications.show({
    position: 'bottom-center',
    autoClose: 6000,
    color: 'red',
    icon: <IconX style={{ width: rem(20), height: rem(20) }} />,
    title: 'Coś poszło nie tak...',
    message,
  })
}

export function toastSuccess(message: string) {
  notifications.show({
    position: 'bottom-center',
    autoClose: 3000,
    color: 'green',
    icon: <IconCheck style={{ width: rem(20), height: rem(20) }} />,
    title: 'Udało się!',
    message,
  })
}
